import React from "react";
import ExperienceItem from "./ExperienceItem";

function ExperienceList({experiences, onEdit, onDelete}) {
    return (
        <div>
            {experiences.length > 0 ? (
              <div className="row row-cols-2 mt-2">
                {experiences.map((experience) => (
                   <div className="col-6" key={experience.id}>
                    <ExperienceItem
                        experience={experience}
                        onEdit={() => onEdit(experience)}
                        onDelete={() => onDelete(experience.id)}
                    />
                    </div>
                ))}
                </div>
            ) : (
                <div className="text-center">
                    <h4>No Experiences</h4>
                    <p className="text-muted small">No experiences added yet. Add your professional experience to build your CV.</p>
                </div>
            )}
        </div>
    );
}

export default ExperienceList;
